<div class="container">
    <div class="d-flex flex-column justify-content-center vh-100">
        <router-outlet></router-outlet>
    </div>
</div>